import React, { useEffect, Fragment, useCallback, useState } from 'react'
import { Button, Modal, Radio } from 'antd'
import { connect } from 'dva'
import TeamTable from './TeamTable'
import TeamManagement from './TeamManagement'
import AddTeam from './AddTeam'
import CreateTeam from './CreateTeam'
import warningIcon from './images/warning.png'
import './Team.module.less'

const Team = ({ dispatch, teamStatus, baseInfo, teamProfile }) => {
  const [key, setKey] = useState('info')

  useEffect(() => {
    dispatch({
      type: 'center/initTeamData',
    })
  }, [dispatch])

  const changeTeamStatus = useCallback(
    (teamStatus) => {
      dispatch({
        type: 'center/save',
        payload: {
          teamStatus,
        },
      })
    },
    [dispatch]
  )

  const handleDissolveTip = useCallback(() => {
    Modal.warning({
      title: '',
      width: 680,
      centered: true,
      closable: true,
      className: 'team-tip',
      maskClosable: true,
      icon: <img styleName="warning-icon" src={warningIcon} />,
      content: '如需解散团队，请发送邮件到security@xiaomi.com并说明原因。',
    })
  }, [])

  const handleOpenQuitTip = useCallback(() => {
    Modal.warning({
      title: '',
      width: 680,
      centered: true,
      closable: true,
      className: 'team-tip',
      maskClosable: true,
      icon: <img styleName="warning-icon" src={warningIcon} />,
      content: baseInfo.isTeamLeader
        ? '如需退出团队并且转让队长，请发送邮件到security@xiaomi.com说明原因及转让对象。'
        : '如需退出团队，请发送邮件到security@xiaomi.com并说明原因。',
    })
  }, [baseInfo.isTeamLeader])

  const { wipJoin, wipCreate } = teamProfile
  const hasWip = wipJoin || wipCreate

  return (
    <div styleName="container">
      <div styleName="content">
        <img styleName="content__image" src={baseInfo.avatar} />
        <span styleName="content__name">{baseInfo.nickname}</span>
      </div>
      <div styleName="content">
        <span styleName="content__info integral">
          贡献值：
          {teamProfile.score || '--'}
        </span>
        <span styleName="content__info">
          年排名：
          {teamProfile.annualRank || '--'}
        </span>
      </div>
      <div styleName="content">
        {teamProfile.name ? (
          <span styleName="content__tip">
            您已加入
            {teamProfile.name}
            队！
          </span>
        ) : (
          <span styleName="content__tip">
            您尚未加入任何团队,可以创建自己的团队或者加入已有团队
          </span>
        )}
      </div>
      {teamProfile.name ? (
        <div styleName="content">
          <Button
            onClick={handleDissolveTip}
            type="primary"
            styleName="content__button left"
            disabled={!baseInfo.isTeamLeader}
          >
            解散团队
          </Button>
          <Button
            onClick={handleOpenQuitTip}
            type="primary"
            styleName="content__button"
          >
            {baseInfo.isTeamLeader ? ' 转让队长' : '退出团队'}
          </Button>
        </div>
      ) : (
        <div styleName="content">
          <Button
            onClick={() => changeTeamStatus('create')}
            type="primary"
            styleName="content__button left"
            disabled={hasWip}
          >
            创建团队
          </Button>
          <Button
            onClick={() => changeTeamStatus('add')}
            type="primary"
            styleName="content__button"
            disabled={hasWip}
          >
            加入团队
          </Button>
        </div>
      )}
      {teamStatus === 'table' ? (
        <div style={{ margin: '70px 50px 0', position: 'relative' }}>
          <Radio.Group
            className="misrc-radio"
            value={key}
            onChange={(e) => setKey(e.target.value)}
          >
            <Radio.Button value="info">团队详情</Radio.Button>
            {!!teamProfile.name && (
              <Radio.Button
                disabled={baseInfo.isTeamLeader === 0}
                value="management"
              >
                加团申请
              </Radio.Button>
            )}
          </Radio.Group>
          {key === 'info' ? <TeamTable /> : <TeamManagement />}
        </div>
      ) : (
        <Fragment>
          {!hasWip && teamStatus === 'add' && (
            <AddTeam changeTeamStatus={changeTeamStatus} />
          )}
          {!hasWip && teamStatus === 'create' && (
            <CreateTeam changeTeamStatus={changeTeamStatus} />
          )}
        </Fragment>
      )}
    </div>
  )
}

export default connect(({ center }) => {
  return {
    teamStatus: center.teamStatus,
    baseInfo: center.baseInfo,
    teamProfile: center.teamProfile,
  }
})(Team)
